export const defaultUiConfig = JSON.stringify({
  'canvas-ROOT': {
    type: { resolvedName: 'Container' },
    isCanvas: true,
    props: {
      padding: 5,
      id: 'rootCanvas',
    },
    nodes: ['canvas-_cBKAwhiJ'],
    custom: {},
    displayName: 'Container',
  },
  'canvas-_cBKAwhiJ': {
    type: { resolvedName: 'Container' },
    isCanvas: true,
    props: { padding: 10 },
    displayName: 'Canvas',
    custom: {},
    index: 0,
    parent: 'canvas-ROOT',
    nodes: [],
  },
});
